import {
    GET_DROPDOWN_OPTIONS_SUCCESS,
    GET_DROPDOWN_OPTIONS_FAILURE,
} from '../actions/actionTypes';

import { put } from 'redux-saga/effects';
import { getDropdownOptionsFunc } from '../../services';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getDropdownOptionsSaga(action) { 
    try {
        const response = yield getDropdownOptionsFunc(action.payload);
        yield put({
            type: GET_DROPDOWN_OPTIONS_SUCCESS,
            payload: {
                dropdownName: action.payload,
                dropdownOptions: response,
            },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/order/${action.payload}`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DROPDOWN_OPTIONS_FAILURE,
            payload: {
                dropdownName: action.payload,
                dropdownOptions: [],
            },
        });
    }
}
